/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { AxesSVG } from '../map-icons/axes';

import { PinSVG } from '../map-icons/pin';
import { SaveSVG } from '../map-icons/save';
import { MapSVG } from '../map-icons/map';
import { ImageSVG } from '../map-icons/image';
import { AntenaSVG } from '../map-icons/antena';
import { ZoneSVG } from '../map-icons/zone';

interface IProps {
  title:string
  status?:boolean
  click:()=>void
  disabled?: boolean
}

export const ControlButton:React.FC<IProps> = ({
  title, status, click, disabled,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [pressed, setPressed] = useState(false);
  const icon: { [key: string]: JSX.Element } = {
    MAP: <MapSVG selected={status} />,
    PIN: <PinSVG selected={status} />,
    IMAGE: <ImageSVG selected={status} />,
    ANTENNA: <AntenaSVG selected={status} />,
    ZONE: <ZoneSVG selected={status} />,
    'SAVE STATE': <SaveSVG selected={pressed} />,
    'LL AXES': <AxesSVG selected={status} />,
    'XY AXES': <AxesSVG selected={status} />,
  };
  return (
    <div
      onClick={(e) => {
        if (disabled) return;
        click();
      }}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => !disabled && setIsHovered(false)}
      onMouseDown={() => !disabled && setPressed(true)}
      onMouseUp={() => !disabled && setPressed(false)}
      style={{
        opacity: isHovered ? 0.7 : 1,
        width: '50px',
        height: '60px',
        borderRadius: '8px',
        backgroundColor: status || pressed ? '#EBE5FF' : '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        cursor: disabled ? 'not-allowed' : undefined,
      }}
    >
      {icon[title]}

      <span style={{
        fontSize: '10px',
        fontWeight: 600,
        textAlign: 'center',
        color: disabled
          ? '#A0A0A0'
          : status
            ? '#3800EE'
            : '#0E0F12',
      }}
      >
        {title}
      </span>
    </div>
  );
};
